import * as styles from "./ComboboxClear.css";

import { clsx } from "clsx";
import { type JSX } from "react";

import { Combobox as BaseCombobox } from "@base-ui/react/combobox";
import { Icon } from "@frontend/components/atoms/Icon";

import type { ComboboxClearProps } from "./Combobox.types";

export function ComboboxClear({
  className,
  children,
  ...props
}: ComboboxClearProps): JSX.Element {
  return (
    <BaseCombobox.Clear
      data-slot="combobox-clear"
      className={clsx(styles.clear, className)}
      {...props}
    >
      {children ?? <Icon name="X" size="sm" />}
    </BaseCombobox.Clear>
  );
}
